class UsuarioLogin {

    uid: string;
    idToken: string;

    constructor(
        uid = '',
        idToken = '',
    ) {
        this.uid = uid;
        this.idToken = idToken;
    }

}

export default UsuarioLogin;
